import { render, staticRenderFns } from "./acount.vue?vue&type=template&id=1db0085a&scoped=true&"
import script from "./acount.vue?vue&type=script&lang=js&"
export * from "./acount.vue?vue&type=script&lang=js&"
import style0 from "./acount.vue?vue&type=style&index=0&id=1db0085a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db0085a",
  null
  
)

export default component.exports